/**
 * Produktname und Marke — bewusst an EINER Stelle.
 *
 * Der Name ImmoAufnahme ist seit 2026-07-29 entschieden. Falls sich die Marke
 * später doch ändert, reicht es, diese Datei zu ändern — im übrigen Code steht
 * nirgends ein Produktname.
 *
 * Später ebenfalls anzupassen (erst kurz vor Store-Release relevant):
 *   - capacitor.config.json → appId / appName (App-ID ist nach Store-Einreichung fest)
 */
export const BRAND = {
	/** Anzeigename in der App, im PDF-Kopf und im Store. */
	name: 'ImmoAufnahme',
	/** Kurzform für enge Stellen (Tab-Leiste, Home-Bildschirm). */
	shortName: 'ImmoAufnahme',
	/** Einzeiler unter dem Namen. Die Differenzierung gehört hierhin, nicht in den Namen. */
	claim: 'Sprechen oder tippen. Fertig protokolliert.',
	/** Öffentliche Kontaktadresse für Website, Impressum und Datenschutz. */
	kontakt: 'info@immoaufnahme.de'
} as const;
